import { render } from "./AssetBhagIntranet.vue?vue&type=template&id=00f02c26&scoped=true&ts=true"
import script from "./AssetBhagIntranet.vue?vue&type=script&lang=ts"
export * from "./AssetBhagIntranet.vue?vue&type=script&lang=ts"

import "./AssetBhagIntranet.vue?vue&type=style&index=0&id=00f02c26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f02c26"]])

export default __exports__